import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminApiService } from '../services/adminApi';
import { useUser } from './UserContext';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [adminUser, setAdminUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { user, isAuthenticated } = useUser();

  const checkAdminStatus = async () => {
    if (!user?.idToken) {
      setAdminUser(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      // Try to access an admin endpoint
      await adminApiService.getCourtTypes(user.idToken);
      
      // If successful, user is admin
      setAdminUser({
        lineUserId: user.lineUserId,
        displayName: user.displayName,
        isAdmin: true,
        idToken: user.idToken
      });
    } catch (err) {
      // User is not admin - this is normal
      setAdminUser(null);
      setError("User is not admin");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated && user?.idToken) {
      checkAdminStatus();
    } else {
      setAdminUser(null);
    }
  }, [isAuthenticated, user?.idToken]);

  const value = {
    adminUser,
    loading,
    error,
    isAdmin: !!adminUser
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
}; 